// extracted by mini-css-extract-plugin
module.exports = {"container":"consequences_container__2IADU","fade-in":"consequences_fade-in__1P8sy","title":"consequences_title__2unt0","description":"consequences_description__2-1vJ"};